<script lang="ts">
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';
    import {getTextFromGridFieldValue} from 'src/features/erp-sutor/sutor-utils';
    import {exists} from 'shared/utils/custom-utils';
    import {FOND_REPORT} from 'src/features/erp-sutor/sutor-fonds';
    import ReportFondDetail from '../components/ReportFondDetail.svelte';
    import ReportName from 'src/features/erp-sutor/features/report-detail/components/ReportName.svelte';
    import GridFieldValue from 'shared/ui-widgets/grid/GridFieldValue.svelte';

    export let record: RecordRow;

    const nameField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.nameFieldId);
    const sellPriceField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.sellPriceFieldId);
    const sellCountField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.sellCountFieldId);
    const sellUnitField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.sellUnitFieldId);
</script>

<ReportFondDetail {record} on:text-note-edit>
    <svelte:fragment slot="heading">
        <ReportName {nameField}/>
    </svelte:fragment>

    <svelte:fragment slot="details">
        <LabeledValue label="Prodej cena">
            <GridFieldValue field={sellPriceField}>
                {getTextFromGridFieldValue(sellPriceField)} {exists(sellPriceField) ? 'Kč' : ''}
                {#if exists(sellUnitField)}/{getTextFromGridFieldValue(sellUnitField)}{/if}
            </GridFieldValue>
        </LabeledValue>

        <LabeledValue label="Prodej množství">
            <GridFieldValue field={sellCountField}>
                {getTextFromGridFieldValue(sellCountField)}
                {#if exists(sellUnitField)} {getTextFromGridFieldValue(sellUnitField)}{/if}
            </GridFieldValue>
        </LabeledValue>
    </svelte:fragment>
</ReportFondDetail>